import React from 'react';
import './style.scss';
import { Image, Text } from '@sitecore-jss/sitecore-jss-react';

const LoginLinks = ({ item, isLoginActive, toggleLoginMenu }) => {
  const menuItems = item?.fields;
  const closeIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-close-white';
  return (
    <div className={`login-menu ${isLoginActive ? 'visible' : ''}`}>
      <div className="login-menu-overlay" onClick={toggleLoginMenu}></div>
      <div className="login-menu-wrapper">
        <div className="login-menu-header">
          <div className="flex-it align-items-center">
            {!!menuItems?.linkIcon?.value?.src && (
              <Image field={item?.fields?.linkIcon} className="ahnl-icon" />
            )}
            <h2>{!!menuItems?.title?.value && <Text field={menuItems.title} />}</h2>
          </div>
          <button className="close-login-btn" onClick={toggleLoginMenu}>
            <img src={closeIcon} alt="close" />
          </button>
        </div>
        <div className="login-item-list">
          {menuItems?.items?.map((item, i) => {
            return (
              <div key={i}>
                <h3>{!!item?.fields?.title?.value && <Text field={item.fields.title} />}</h3>
                <ul>
                  {item?.fields?.items?.map((subItem, j) => {
                    const title = subItem?.fields?.link?.value?.text;
                    return (
                      title && (
                        <li key={j}>
                          <a href={subItem?.fields?.link?.value?.href}>{title}</a>
                        </li>
                      )
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LoginLinks;
